import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import { Activity } from "@mapmycustomers/shared/types/entity";

import Note from "./Note";

const NoteCellRenderer: React.FC<ICellRendererParams> = ({ node }) => (
  <Note activity={node.data as Activity} />
);

export default NoteCellRenderer;
